<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Payment Reports</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="flex-grow mr-4" @reset="reset">
        <div class="p-2">
          <label class="block text-gray-700">Status:</label>
          <select v-model="form.status" class="mt-1 w-full form-select">
            <option :value="null">All</option>
            <option v-for="(status, key) in statuses" :value="key">{{ status }}</option>
          </select>
        </div>
      </search-filter>

      <div class="flex gap-4">
        <InertiaLink class="btn-primary" :href="route('manage.payments-report.match-orders')">Match Orders</InertiaLink>
        <InertiaLink class="btn-primary" :href="route('manage.payments-report.match-orders')">Match Invoices</InertiaLink>
      </div>
    </div>

    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">ID</th>
          <th class="px-6 pt-6 pb-4">Customer</th>
          <th class="px-6 pt-6 pb-4">Ref No.</th>
          <th class="px-6 pt-6 pb-4">Date</th>
          <th class="px-6 pt-6 pb-4 pr-3 text-right">Amount</th>
          <th class="px-6 pt-6 pb-4">Description</th>
          <th class="px-6 pt-6 pb-4">Updated At</th>
          <th></th>
        </tr>
        <tr v-for="row in payments.data" :key="row.id" class="hover:bg-gray-100 focus-within:bg-gray-100 text-sm">
          <td class="border-t">
            <inertia-link class="px-4 flex items-center" :href="route('manage.payments-report.show', row.id)" tabindex="-1">
              <span class="px-6 py-4 flex items-center focus:text-indigo-500">
              {{ row.id }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-4 flex items-center" :href="route('manage.payments-report.show', row.id)" tabindex="-1">
              <span class="px-6 py-4 flex items-center focus:text-indigo-500">
              {{ row.customer && row.customer.name }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-4 flex items-center" :href="route('manage.payments-report.show', row.id)" tabindex="-1">
              <span class="px-6 py-4 flex items-center focus:text-indigo-500">
              {{ row.reference_no }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-4 flex items-center" :href="route('manage.payments-report.show', row.id)" tabindex="-1">
              <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                {{ row.date | localDate }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t text-right pr-3">
            <inertia-link class="px-4 flex items-center" :href="route('manage.payments-report.show', row.id)" tabindex="-1">
              {{ row.amount.toLocaleString() }}
            </inertia-link>
          </td>
          <td class="border-t  flex justify-start items-center focus:text-indigo-500">
            <inertia-link class="px-4 flex items-center" :href="route('manage.payments-report.show', row.id)" tabindex="-1">
            <div class="px-6 py-2">
              <div>
                {{ row.description }}
              </div>
              <div v-if="row.remarks" class="italic text-xs">
                Remarks: {{ row.remarks }}
              </div>
            </div>
            </inertia-link>
          </td>

          <td class="border-t">
            <inertia-link class="px-4 flex items-center" :href="route('manage.payments-report.show', row.id)" tabindex="-1">
              <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                {{ row.updated_at | localDateTime }}
              </span>
            </inertia-link>
          </td>

          <td class="border-t">
            <inertia-link class="px-4 flex items-center" :href="route('manage.payments-report.show', row.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>

        </tr>
        <tr v-if="payments.data.length === 0">
          <td class="border-t px-6 py-4" colspan="5">No payments found.</td>
        </tr>
      </table>
    </div>
    <pagination :links="payments.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Admin/Layout'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  layout: Layout,
  components: {
    LoadingButton,
    Icon,
    Pagination,
    SearchFilter
  },

  props: {
    payments: Object,
    stats: Object,
    filters: Object,
    statuses: Object,
  },

  data() {
    return {
      form: {
        approved: this.filters.approved || null
      }
    }
  },

  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form)
        this.$inertia.get(this.route('manage.payments', Object.keys(query).length ? query : { remember: 'forget'}), {}, { preserveState: true })
      }, 150),
      deep: true,
    },
  },

  methods: {
    reset() {
      this.form = {
        search: null,
        atoll: null,
        approved: null
      }
    }
  }
}
</script>
